import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { PartiesState } from './parties.state';
import { PartiesStore } from './parties.store';

@Injectable({ providedIn: 'root' })
export class PartiesQuery extends QueryEntity<PartiesState> {
  constructor(protected readonly store: PartiesStore) {
    super(store);
  }
}
